import { DataSource } from '@angular/cdk/collections';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'kt-chatbot-dialog',
  templateUrl: './chatbot-dialog.component.html',
  styleUrls: ['./chatbot-dialog.component.scss']
})
export class ChatbotDialogComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource = new MatTableDataSource<any>();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { type: string, data: any },
    private dialogRef: MatDialogRef<ChatbotDialogComponent>
  ) { }

  totalColumns: any[]
  stickyColumnNames: any[]
  scrollableColumnNames: any[]

  ngOnInit(): void {
    if (this.data.type == 'table') {
      this.dataSource.data = this.data.data
      this.getDisplayedColumns(this.dataSource.data);
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  getDisplayedColumns(data: any[]): void {
    this.totalColumns = data.length ? Object.keys(data[0]) : [];
    this.stickyColumnNames = this.totalColumns.slice(0, 2);
    this.scrollableColumnNames = this.totalColumns.slice(2);
  }

  isUtcDate(value: string): boolean {
    // Check if the value matches the format 'YYYY-MM-DD HH:mm:ss UTC'
    return typeof value === 'string' && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2} UTC$/.test(value);
  }

  // Convert UTC date string (format: 'YYYY-MM-DD HH:mm:ss UTC') to IST
  convertToIST(utcDate: string): string {
    // Remove the " UTC" part to make it parseable
    const formattedDate = utcDate.replace(' UTC', 'Z');
    const date = new Date(formattedDate);

    // Add 330 minutes to convert to IST (Indian Standard Time)
    const istDate = new Date(date.getTime() + (330 * 60 * 1000));

    // Format the IST date and time
    return istDate.toLocaleString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
